import React from "react";
import { observer } from "mobx-react";
import { CurrencyCreateStore } from "../../store";
import { CurrencyCreateForm } from "./CurrencyCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type CurrencyCreateProps = {
  currencyCreateStore: CurrencyCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CurrencyCreate: React.FC<CurrencyCreateProps> = observer(
  ({ currencyCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={currencyCreateStore.isSaving} />
        <CurrencyCreateForm
          currencyCreateStore={currencyCreateStore}
          codeError={currencyCreateStore.errors.code?.message}
          onCodeChange={(value: string) => {
            currencyCreateStore.setCodeValue(value);
          }}
          code={currencyCreateStore.entityValues.code}
          nameError={currencyCreateStore.errors.name?.message}
          onNameChange={(value: string) => {
            currencyCreateStore.setNameValue(value);
          }}
          name={currencyCreateStore.entityValues.name}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={currencyCreateStore.isProcessing}
          onSave={() => currencyCreateStore.saveNewCurrency()}
          onCancel={() => currencyCreateStore.cancelNewCurrency()}
        />
        <ErrorDialog
          open={currencyCreateStore.errorDialogOpened}
          title={currencyCreateStore.errorTitle}
          description={currencyCreateStore.errorDescription}
          onClose={() => currencyCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
